//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
/**
 * Created by z003f2zh on 20.01.2016.
 */

(function () {

    'use strict';

    angular.module('container.layout')
        .factory('navigationService', navigationService);

    function navigationService($rootScope) {

        var service = {};

        var states = [];

        service.addState = function (id, label, name, position, enabled) {

            if (position == null)

                position = states.length;

            var state = new State(id, label, name, null, enabled);
            states.splice(position, 0, state);

            notify();
        };

        service.addStateWithMenu = function (id, label, name, functionMenu, position, enabled) {

            if (position === null)
                position = states.length;

            var state = new State(id, label, name, functionMenu, enabled);
            states.splice(position, 0, state);

            notify();
        };

        service.removeState = function (id) {

            _.remove(states, function (state) {
                return state.id == id;
            });

            notify();
        };

        service.removeStates = function () {

            states = [];

            notify();
        };

        service.getState = function (id) {
            return _.find(states, function (state) { return state.id == id; });
        };

        service.getStates = function () {
            return states;
        };

        function notify() {
            $rootScope.$emit('navigationService:statesChanged');
        }

        return service;
    }

    function State(id, label, name, functionMenu, enabled) {
        this.id = id;
        this.label = label;
        this.name = name;
        this.functionMenu = functionMenu;
        this.enabled = enabled;
    }
})();